import { QueryClient, QueryCache, MutationCache } from "@tanstack/react-query"

export const mutationCache = new MutationCache({})
export const queryCache = new QueryCache({})
export const queryClient = new QueryClient({
  queryCache,
  mutationCache,
  defaultOptions: {
    queries: {
      retry: false,
    },
    mutations: {
      retry: false,
    },
  },
})
